
import React, { useState, useEffect } from 'react';
import MediaAsset from '../mediaAsset/MediaAsset';
import './CountdownContainer.css';

function CountdownContainer({ targetDate, countdownLabels, countdownText = '', mediaProps }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const target = new Date(targetDate);
      const now = new Date();
      const difference = target - now;
      
      const newTimeLeft = {
        days: Math.max(0, Math.floor(difference / (1000 * 60 * 60 * 24))),
        hours: Math.max(0, Math.floor((difference / (1000 * 60 * 60)) % 24)),
        minutes: Math.max(0, Math.floor((difference / 1000 / 60) % 60)),
        seconds: Math.max(0, Math.floor((difference / 1000) % 60))
      };
      
      setTimeLeft(newTimeLeft);
    };

    const timer = setInterval(calculateTimeLeft, 1000);
    calculateTimeLeft();

    return () => clearInterval(timer);
  }, [targetDate]);

  const countdownContent = (
    <>
      <div>
      <div className="countdown-grid">
        <div className="countdown-item">
          <span className="countdown-number">{timeLeft.days}</span>
          <span className="countdown-label">|</span>
          <span className="countdown-label">{countdownLabels.days}</span>
        </div>
        <div className="countdown-item">
          <span className="countdown-number">{timeLeft.hours}</span>
          <span className="countdown-label">|</span>
          <span className="countdown-label">{countdownLabels.hours}</span>
        </div>
        <div className="countdown-item">
          <span className="countdown-number">{timeLeft.minutes}</span>
          <span className="countdown-label">|</span>
          <span className="countdown-label">{countdownLabels.minutes}</span>
        </div>
        <div className="countdown-item">
          <span className="countdown-number">{timeLeft.seconds}</span>
          <span className="countdown-label">|</span>
          <span className="countdown-label">{countdownLabels.seconds}</span>
        </div>
      </div>
      <div className="countdown-title">{countdownText}</div>
      </div>
    </>
  );

  return (
    <MediaAsset
      {...mediaProps}
      overlayContent={countdownContent}
    />
  );
}

export default CountdownContainer;